module.exports = __webpack_public_path__ + "static/media/404.73356b45.jpeg";